// extracted by mini-css-extract-plugin
export default {"productDescription":"pda-z","featuredDescription":"qda-z","description":"rda-z","more":"sda-z","descriptionSku":"tda-z"};